/** Must match backend DEFAULT_SIGNUP_CREDITS on the API server. */
export const SIGNUP_CREDITS = Number(process.env.REACT_APP_SIGNUP_CREDITS) || 10;

export const CREDITS_BALANCE_REFRESH_EVENT = "removebg:credits-balance-changed";

/**
 * Tell Sidebar / Dashboard / Tools the wallet changed.
 * Prefer passing `balance` from the API `remaining_credits` so the UI updates
 * without another network round-trip.
 * @param {number|null|undefined} [balance]
 */
export function publishCreditsBalanceChanged(balance) {
  try {
    // Lazy import avoids circular deps with accountBootstrap ↔ api modules.
    import("../../services/api/app/accountBootstrap")
      .then((mod) => mod.invalidateAccountBootstrap?.())
      .catch(() => {});
  } catch {
    // ignore
  }

  const n = Number(balance);
  window.dispatchEvent(
    new CustomEvent(CREDITS_BALANCE_REFRESH_EVENT, {
      detail: Number.isFinite(n) ? { balance: n } : {},
    }),
  );
}

/**
 * If a tool/API JSON body includes remaining_credits, refresh the left-nav meter.
 * @param {unknown} data
 */
export function publishCreditsFromApiPayload(data) {
  if (!data || typeof data !== "object") return;
  const remaining = data.remaining_credits ?? data.credits;
  if (remaining == null) return;
  // Only treat as wallet update when remaining_credits is present (tool spend),
  // or when this is explicitly a balance-shaped payload.
  if (
    Object.prototype.hasOwnProperty.call(data, "remaining_credits") ||
    (Object.prototype.hasOwnProperty.call(data, "credits") &&
      !Object.prototype.hasOwnProperty.call(data, "benefits"))
  ) {
    const n = Number(remaining);
    if (Number.isFinite(n)) publishCreditsBalanceChanged(n);
  }
}
